import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { evaluatePasswordStrength, passwordCriteriaList } from '../utils/passwordStrength';

interface PasswordStrengthChecklistProps {
  password: string;
}

export function PasswordStrengthChecklist({ password }: PasswordStrengthChecklistProps) {
  if (!password) {
    return (
      <Typography variant="caption" color="text.secondary">
        Minimo 10 caratteri e almeno 3 tra: maiuscole, minuscole, cifre, simboli.
      </Typography>
    );
  }

  const strength = evaluatePasswordStrength(password);
  const items = passwordCriteriaList(strength);

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 0.5 }}>
        Requisiti password
      </Typography>
      <List dense disablePadding>
        {items.map((item) => (
          <ListItem key={item.key} dense disableGutters sx={{ py: 0 }}>
            <ListItemIcon sx={{ minWidth: 28 }}>
              {item.ok ? (
                <CheckCircleIcon color="success" sx={{ fontSize: 18 }} />
              ) : (
                <CancelIcon color="error" sx={{ fontSize: 18 }} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                variant: 'caption',
                color: item.ok ? 'success.main' : 'error',
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
